"use client";
import { useEffect, useRef, useState } from "react";
import { useAtom } from "jotai";
import SVG from "react-inlinesvg";
import Image from "next/image";
import { useParams } from "next/navigation";
import { InView, useInView } from "react-intersection-observer";
import {rules, rulesView} from "@/scripts/data";
import InViewAnimation from "@/components/utils/InViewAnimation";

import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(useGSAP);


export default function PageComponent({}) {
  const [currentId, set_currentId] = useState(1);

  const buttonPagenation = (id) => {
    gsap.to( window, {
      duration: 1,
      ease: 'power2.inOut',
      scrollTo: {
        y: document.querySelector(`.dummy.rules-view .rules-view-item#rule${id}`),
        autoKill: false
      }
    });
  }
  
  return (
    <main className="page page-rules">
      <InViewAnimation>
        <section className="section-rules-kv">
          <div className="page-title-holder">
            <h1 className="h1-title">
              <span className="title en">10 Rules</span>
              <span className="shoulder">Next Green Revolutionに向けた10の合言葉</span>
            </h1>
            <div className="text-lead bold">
              農家、大学、企業、生活者が一緒になって<br />
              新たな農業の未来を叶えるため <br className="spOnly"/>「10の合言葉」を掲げています。
            </div>
          </div>
          <button className="button-scroll button-round scaleHover size-s en medi" type="button" onClick={() => {
            buttonPagenation(1)
          }}>
            <span className="inner">
              Scroll
              <i className="icon">
                <SVG src="/assets/img/common/icon/icon-arrow-bottom.svg" />
              </i>
            </span>
          </button>
        </section>
      </InViewAnimation>

      <section className="section-rules">
        <div className="dummy rules-view">
          {rulesView.map((item,i) => (
            <RulesViewDummy item={item} key={item.id} set_currentId={set_currentId} />
          ))}
        </div>
        <div className="rules-main rules-view">
          {rulesView.map((item,i) => (
            <RulesView item={item} key={item.id}/>
          ))}
          <div className="pagenation-container pcOnly">
            <div className="pagenation">
              <button className="button-pagenation" disabled={currentId == 1} type="button" onClick={() => {
                buttonPagenation(currentId-1)
              }}>
                <i className="icon">
                  <SVG src="/assets/img/common/icon/icon-arrow-top.svg" />
                </i>
              </button>
              <div className="pages">
                <div className="number en">{currentId}</div>
                <div className="div"></div>
                <div className="number en">{rules.length}</div>
              </div>
              <button className="button-pagenation" disabled={currentId == rules.length} type="button" onClick={() => {
                buttonPagenation(currentId+1)
              }}>
                <i className="icon">
                  <SVG src="/assets/img/common/icon/icon-arrow-bottom.svg" />
                </i>
              </button>
            </div>
          </div>
        </div>

        <div className="rules-list">
          {rules.map((item,i) => (
            <div className={`rules-list-item n${item.id}`} key={item.id}>
              <div className="pic">
                <img src={`/assets/img/rules/thumbnail/pic-${item.id}.jpg`} loading="lazy" />
              </div>
              <div className="rules-title">
                <div className="number bold en">{item.id}</div>
                <h2 className="title bold" dangerouslySetInnerHTML={{__html:item.title}}></h2>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

const RulesViewDummy = ({item, set_currentId}) => {
  const { ref, inView, entry } = useInView({
    rootMargin: "-25% 0px -75% 0px",
  });

  useEffect(() => {
    if(inView)set_currentId(item.id)
  },[inView])

  return (
    <div ref={ref} className={`rules-view-item n${item.id}`} id={`rule${item.id}`}>
      <div className="pic">
        <img src={`/assets/img/rules/pic-${item.id}.jpg`} loading="lazy" />
      </div>
      <div className="rules-title">
        <div className="number en">{item.id}</div>
        <h2 className="title bold" dangerouslySetInnerHTML={{__html:item.title}}></h2>
      </div>
    </div>
  )
}

const RulesView = ({item}) => {
  const rulesViewItem = useRef(null);
  useGSAP(
    () => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: rulesViewItem.current,
          start: 'top top',
          scrub: 1
        }
      });
      tl.to(".overlay",{opacity: 1})
    },
    { scope: rulesViewItem }
  );

  return (
    <div ref={rulesViewItem} className={`rules-view-item n${item.id}`}>
      <div className="pic">
        <img src={`/assets/img/rules/pic-${item.id}.jpg`} loading="lazy" />
      </div>
      <div className="rules-title">
        <div className="number en">{item.id}</div>
        <h2 className="title bold" dangerouslySetInnerHTML={{__html:item.title}}></h2>
      </div>
      <div className="overlay"></div>
    </div>
  )
}